<div
  *ngIf="posts.length > 0 || alerts.length > 0"
  class="grid grid-cols-1 gap-5">

  <app-latest-posts
    [posts]="posts"
    [maxSidebarCards]="maxSidebarCards"
    [naPlaceholder]="naPlaceholder"
    (viewPost)="viewRow($event)">
  </app-latest-posts>

  <app-latest-alerts
    [alerts]="alerts"
    [maxSidebarCards]="maxSidebarCards"
    [naPlaceholder]="naPlaceholder"
    (viewAlert)="viewAlert($event)">
  </app-latest-alerts>

</div>